import { Icon } from '@ui'
import css from './imagesProgressBar.module.scss'
import cx from 'classnames'
import SmallProgressBar from '@ui/SamllProgressBar/SamllProgressBar'
import React, { FC } from 'react'

type ImagesProgressBarProps = {
  progressPercent: number
  currentFilesCount: number
  totalFilesCount: number
}
export const ImagesProgressBar: FC<React.PropsWithChildren<ImagesProgressBarProps>> = ({
  progressPercent,
  currentFilesCount,
  totalFilesCount,
}) => {
  const isUploadingDone = () => progressPercent === 100

  return (
    <div className={css.progressBar}>
      {isUploadingDone() ? (
        <>
          <Icon light name="circle-check" className={cx('fa-solid', css.iconCheck)} />
          <div className={css.uploadingMessage}>
            <p>{`Uploded ${currentFilesCount} out of ${totalFilesCount} files...`}</p>
          </div>
        </>
      ) : (
        <>
          <Icon light name="folder-image" className={cx('fa-light', css.imageIcon)} />
          <div className={css.uploadingMessage}>
            <p>{`Uploding ${currentFilesCount} out of ${totalFilesCount} files...`}</p>
          </div>
        </>
      )}

      <div>
        <SmallProgressBar progressPercent={progressPercent} />
      </div>
    </div>
  )
}
